import { min } from "lodash";
import { observer } from "mobx-react"; // Importing observer from mobx-react for state management
import React from "react"; // Importing React
import { FormattedMessage } from "react-intl";

const Minutes: React.FC<{
  minutes: any; // Prop for minute labels or data
  hoursShown: any; // Prop for the number of hours to display
  minuteColumnWidthPx: any; // Prop for the width of each minute column in pixels
}> = ({ minutes, hoursShown, minuteColumnWidthPx }) => {
  const columnWidth = (12 / minutes.length) * minuteColumnWidthPx;
  const halfHourWidth = columnWidth * (minutes.length / 2);
  return (
    <React.Fragment>
      {[...Array(hoursShown)].map((_, h) => // Loop through the number of hours to display
        minutes.map((m: any, i: any) => ( // Loop through the minutes for each hour
          <th
            key={`${h}-${i}`} // Unique key for each <th> element
            className="minute-column" // CSS class for styling
            colSpan={12 / minutes.length} // Set column span based on the number of minutes
            style={{
              width: `${columnWidth}px`, // Set the width of the column
            }}
          >
            {m} {/* Render the minute label or data */}
          </th>
        ))
      )}
    </React.Fragment>
  );
};

export default observer(Minutes); // Exporting the component wrapped with observer
